import React, { useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Popover,
  OverlayTrigger,
} from "react-bootstrap";
import TimerComponent from "./TimerComponent";
import "./styles.scss";
import MdCalculator from "../../constants/icons/Md/MdCalculator";
import BsTask from "../../constants/icons/Bs/BsTask";
import ElEdit from "../../constants/icons/El/edit";
import FiChevronUp from "../../constants/icons/Fi/FiChevronUp";
import FiChevronDown from "../../constants/icons/Fi/FiChevronDown";
import MathDirections from "./MathDirections";
import MdFunctions from "../../constants/icons/Md/MdFunctions";

const Header = ({
  examData,
  handleAnnotateClick,
  currentSectionIndex,
  toggleCalculator,
  handleTimerEnd,
  saveAndExit = () => {},
  time,
  toggleRefernce,
}) => {
  const [show, setShow] = useState(false);
  const target = useRef(null);
  // This will toggle the visibility of the popover
  const handleClick = () => setShow(!show);

  const popover = (
    <Popover id="popover-basic">
      <Popover.Body
        style={{
          position: "relative",
          height: "100%",
          padding: "15px",
          marginTop: "10px",
          fontSize: "20px",
        }}
      >
        {currentSectionIndex === 0 || currentSectionIndex === 1 ? (
          <>
            The questions in this section address a number of important reading
            and writing skills. Each question includes one or more passages,
            which may include a table or graph. Read each passage and question
            carefully, and then choose the best answer to the question based on
            the passage(s).
            <div style={{ marginTop: "10px" }}>
              All questions in this section are multiple-choice with four answer
              choices. Each question has a single best answer
            </div>
          </>
        ) : (
          <MathDirections />
        )}

        <div
          className="w-100 d-flex justify-content-end align-items-end"
          style={{ position: "absolute", bottom: 18, right: 15 }}
        >
          <Button
            variant="link"
            onClick={handleClick}
            style={{
              padding: 0,
              textDecoration: "none",
              color: "black",
              backgroundColor: "rgb(254, 219, 2)",
              border: "1px solid black",
              borderRadius: "25px",
              fontSize: "18px",
              fontWeight: "700",
              width: "100px",
              height: "45px",
              // Removed height style
              zIndex: 1, // Optional: Add z-index if needed
            }}
          >
            Close
          </Button>
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <Container
      fluid
      style={{
        marginTop: "0.5rem",
        marginBottom: "0.5rem",
      }}
    >
      <Row className={`align-items-center px-5 exam-header-row`}>
        <Col sm={4}>
          <div
            className="exam-header-section-name"
            style={{
              fontSize: "20px",
              fontWeight: "600",
              whiteSpace: "nowrap",
            }}
          >
            {examData?.sections[currentSectionIndex]?.name}
          </div>
          <div style={{ fontSize: "12px" }}>
            <OverlayTrigger
              trigger="click"
              placement="bottom"
              overlay={popover}
              show={show} // Controlled by the show state
              target={target.current}
            >
              <Button
                variant="link"
                ref={target} // Assign the ref to the button
                onClick={handleClick}
                style={{
                  padding: 0,
                  fontSize: "14px",
                  textDecoration: "none",
                  color: "black",
                }}
              >
                Directions {show ? <FiChevronUp /> : <FiChevronDown />}
              </Button>
            </OverlayTrigger>
          </div>
        </Col>

        <Col sm={4} className="d-flex justify-content-center">
          <TimerComponent
            initialTime={time}
            onTimerEnd={handleTimerEnd}
            currentSectionIndex={currentSectionIndex}
          />
        </Col>

        <Col sm={4} style={{ display: "flex", justifyContent: "flex-end" }}>
          {examData?.sections &&
            examData?.sections[currentSectionIndex] &&
            examData?.sections[currentSectionIndex]?.canAccessCalculator && (
              <div onClick={toggleCalculator} style={{ cursor: "pointer" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    color: "black",
                  }}
                >
                  <MdCalculator size={20} />
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    padding: "0px 10px 0px 10px",
                    fontWeight: 700,
                  }}
                >
                  Calculator
                </div>
              </div>
            )}
          {examData?.sections &&
            examData?.sections[currentSectionIndex] &&
            examData?.sections[currentSectionIndex]?.canAccessReference && (
              <div onClick={toggleRefernce} style={{ cursor: "pointer" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    color: "black",
                  }}
                >
                  <MdFunctions size={20} />
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    padding: "0px 10px 0px 10px",
                    fontWeight: 700,
                  }}
                >
                  Reference
                </div>
              </div>
            )}
          {examData?.sections &&
            examData?.sections[currentSectionIndex] &&
            examData?.sections[currentSectionIndex]?.canAccessAnnotation && (
              <div onClick={handleAnnotateClick} style={{ cursor: "pointer" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    color: "black",
                  }}
                >
                  <ElEdit size={20} />
                </div>
                <div
                  style={{
                    fontSize: "14px",
                    padding: "0px 10px 0px 10px",
                    fontWeight: 700,
                  }}
                >
                  Annotate
                </div>
              </div>
            )}
          {/* Save & Exit button */}
          {examData?.canResumeAssessment && (
            <div onClick={saveAndExit} style={{ cursor: "pointer" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  color: "black",
                }}
              >
                <BsTask size={20} />
              </div>
              <div
                style={{
                  fontSize: "14px",
                  padding: "0px 10px 0px 10px",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                }}
              >
                Save & Exit
              </div>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default Header;
